import type { ISignupLocale } from '@/Pages/Onboard/SignUp/Locale/Signup.locale';

const ptBR: ISignupLocale = {
  title: 'Crie sua conta {brand}',
  subtitle: 'Junte-se a nós e inicie sua jornada com análises poderosas.',
  firstName: {
    label: 'Nome',
    placeholder: 'Digite seu nome',
    error: 'Nome é obrigatório',
  },
  lastName: {
    label: 'Sobrenome',
    placeholder: 'Digite seu sobrenome',
    error: 'Sobrenome é obrigatório',
  },
  email: {
    label: 'Endereço de Email',
    placeholder: 'Digite seu endereço de email',
    error: 'Endereço de email é obrigatório',
    invalidError: 'Por favor, digite um endereço de email válido',
  },
  password: {
    label: 'Senha',
    placeholder: 'Crie uma senha forte',
    error:
      'A senha deve ter pelo menos 8 caracteres com maiúscula, minúscula, número e caractere especial',
    validationTitle: 'A senha deve conter:',
    validationMinLength: 'Pelo menos 8 caracteres',
    validationUppercase: 'Pelo menos uma letra maiúscula',
    validationLowercase: 'Pelo menos uma letra minúscula',
    validationNumber: 'Pelo menos um número',
    validationSpecialChar: 'Pelo menos um caractere especial',
  },
  confirmPassword: {
    label: 'Confirmar Senha',
    placeholder: 'Confirme sua senha',
    error: 'Por favor, confirme sua senha',
    mismatchError: 'As senhas não coincidem',
  },
  button: {
    signup: 'Criar Conta',
    signingUp: 'Criando Conta...',
  },
  terms: {
    prefix: 'Ao criar uma conta, você concorda com nossos',
    terms: 'Termos de Serviço',
    and: 'e',
    privacy: 'Política de Privacidade',
    suffix: '.',
  },
  success: {
    title: 'Conta criada com sucesso!',
    message: 'Bem-vindo ao Sonarprint! Verifique seu email para verificar sua conta.',
  },
  backToLogin: {
    text: 'Já tem uma conta? Fazer login',
    link: 'Fazer login',
  },
};

export { ptBR };
